"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.mockAlgoliaProduct = exports.mockAlgoliaWaterbody = void 0;
const waterbody_1 = require("./waterbody");
function mockAlgoliaWaterbody(overrides = {}) {
    return {
        ...(0, waterbody_1.mockWaterbody)(overrides),
        _highlightResult: {
            primary_name: {
                value: '<em>lake</em> mockley',
            },
        },
        objectID: '234123849-2134234-123412341234-1234',
        states: ['MN'],
        counties: ['Ramsey'],
        indexed_at: 1663002431,
        _geoloc: {
            lat: 43.6345487322704,
            lng: -93.3414087584442,
        },
        ...overrides,
    };
}
exports.mockAlgoliaWaterbody = mockAlgoliaWaterbody;
function mockAlgoliaProduct(overrides = {}) {
    return {
        _highlightResult: {
            title: {
                value: '<em>mock</em> ripper',
            },
        },
        objectID: 'MOCK-PR-DCT',
        id: 12345,
        img_url: 'http://example.com/jpg.jpg',
        shopify_options: [
            {
                name: 'Length',
                value: '2"',
            },
            {
                name: 'COLOR',
                value: 'CHROME',
            },
        ],
        shopify_product_handle: 'mock-handle',
        sku: 'FAKE-SKU',
        title: 'mock ripper 2" chrome',
        ...overrides,
    };
}
exports.mockAlgoliaProduct = mockAlgoliaProduct;
